class CollectionPromo extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (window.Nosto) {
      this.checkForNosto()
    }
  }

  checkForNosto () {
    const nostoPromo = document.querySelector('#nosto-collection-promo')
    if (!nostoPromo) return

    const clonePromo = nostoPromo.cloneNode(true)

    this.innerHTML = clonePromo.innerHTML
  }
}

if (!customElements.get('collection-promo')) {
  customElements.define('collection-promo', CollectionPromo)
}
